var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.color,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.iconName)?[_c('i',{class:("zmdi zmdi-hc-2x zmdi-" + _vm.iconName)}),_c('br')]:_vm._e(),(_vm.iconImage)?_c('div',{staticClass:"image",style:({
    backgroundImage: ("url(" + _vm.iconImage + ")")
  })}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }